<script>
import axios from 'axios';
import { mapActions } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';
import auth from '../../auth';


export default {
    name: 'CpSocialFeedSignUpPost',
    components: {
        CpButton: require('../../button').default,
        CpRecaptcha: require('../../recaptcha').default,
        VueSimpleSpinner: require('../../vue-simple-spinner').default,
    },
    directives: {
        margin: require('../../directives/margins').margin,
        marginBottom: require('../../directives/margins').marginBottom,
        marginRight: require('../../directives/margins').marginRight,
    },
    data() {
        return {
            action: '/user/login',
            token: this.$root.csrfToken,
            provider: null,
            recaptchaVerification: null,
            recaptchaSiteKey: process.env.MIX_RECAPTCHA_PUBLIC_KEY,
            loading: false,
            showRecaptcha: false,
        };
    },
    methods: {
        redirectToSignUp() {
            const socialMediaBtns = document.querySelectorAll('.btn-border-radius');
            const displayLoading = document.querySelector('.display-loading');
            socialMediaBtns.forEach(function (btn) {
                btn.style.display = 'none';
            });
            displayLoading.style.display = 'block';

            window.location.href = "/user/login?create";
        },
        async handleFormSubmit(provider) {
            this.showRecaptcha = true;
            try {
                const callback = async (data) => {
                    await this.checkUserLogin(this.$root._handleCheckResponse);
                    await this.handleSocialNetworkSignUp(data.isSignup === '1');
                }

                auth.loginWithSocialMedia(provider, callback);
            } catch (error) {
                console.error(error);
                this.showRecaptcha = false;
            }
            // const socialMediaBtns = document.querySelectorAll('.btn-border-radius');
            // const displayLoading = document.querySelector('.display-loading');
            // socialMediaBtns.forEach(function (btn) {
            //     btn.style.display = 'none';
            // });
            // displayLoading.style.display = 'block';

            // this.loading = true;
            // this.provider = provider;
            // if (!this.recaptchaVerification && this.$refs.recaptcha) {
            //     this.$refs.recaptcha.reset();
            //     this.$refs.recaptcha.execute();
            //     this.loading = false;
            // } else {
            //     await this.$nextTick();
            //     this.$refs.form.submit();
            // }
        },
        handleRecaptchaVerify(response) {
            this.loading = true;
            this.recaptchaVerification = response;
            this.showRecaptcha = false;
            this.handleFormSubmit(this.provider);
        },
        handleRecaptchaExpired() {
            this.recaptchaVerification = null;
        },
        ...mapActions(useUserStore, ['checkUserLogin', 'handleSocialNetworkSignUp']),
    }
};
</script>

<template>
    <div class="container">
        <h3 class="buttons black-color title-text">Sign up to receive the most recent activity!</h3>
        <form ref="form" class="auth-form formContainer" method="POST" :action="action">
            <input type="hidden" v-if="token" name="_token" :value="token" />
            <input type="hidden" name="remember" :value="1" />
            <input type="hidden" name="is_existing" value="0" />
            <input type="hidden" name="is_provider" value="1" />
            <input type="hidden" name="provider" :value="provider" />
            <cp-recaptcha v-if="showRecaptcha" ref="recaptcha" :sitekey="recaptchaSiteKey" @verify="handleRecaptchaVerify"
                @expired="handleRecaptchaExpired">
                <button type="button" hidden>I'm not a robot</button>
            </cp-recaptcha>

        </form>
        <div class="display-loading"><vue-simple-spinner v-margin="1" /></div>
        <div>
            <button :disabled="loading" @click="handleFormSubmit('google')" class="btn-border-radius social-media-btn"
                v-margin-bottom="0.5">
                <div class="btn-text-container"><img src="/assets/img/google-icon.svg" v-margin-right="0.5" /><span
                        class="subheadline2 neutral4-color">Sign up with Google</span></div>
            </button>
            <button :disabled="loading" @click="handleFormSubmit('twitter')" class="btn-border-radius social-media-btn"
                v-margin-bottom="0.5">
                <div class="btn-text-container"><img src="/assets/img/twitter-x-icon.svg" v-margin-right="0.5" /><span
                        class="subheadline2 neutral4-color">Sign up with X
                        (Twitter)</span></div>
            </button>
            <button :disabled="loading" @click="handleFormSubmit('facebook')" class="btn-border-radius social-media-btn"
                v-margin-bottom="0.5">
                <div class="btn-text-container"><img src="/assets/img/facebook-icon.svg" class="twitter-img"
                        v-margin-right="0.5" width="24" /><span class="subheadline2 neutral4-color">Sign up with
                        Facebook</span></div>
            </button>
        </div>

        <cp-button v-if="!loading" class="btn-border-radius" primary block @click="redirectToSignUp">Create an
            account</cp-button>
        <p class="footnote neutral4-color">By logging in or signing up you agree to the terms of service and privacy
            policy.</p>
    </div>
</template>

<style scoped>
.container {
    padding: 16px;
    border: 1px solid var(--primary);
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px #00000033;
    background-color: var(--white);
}

.title-text {
    text-align: center;
    padding: 0 8px;
}

.btn-border-radius {
    border-radius: 40px;
}

.social-media-btn {
    display: flex;
    padding: 0px 16px;
    min-height: 40px;
    border: 1px solid var(--primary-blue-400);
    cursor: pointer;
    width: 100%;
    align-items: center;
    background-color: white;
}

.twitter-img {
    width: 24px;
}

.btn-text-container {
    display: flex;
    align-items: center;
}

.display-loading {
    display: none;
}

@media screen and (max-width: 768px) {
    .container {
        max-width: 250px;
    }
}
</style>